import { getDialCodeList } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/utils/getDialCodeList';

export const getDialCodeItemFromList = (dialCode: string | undefined, availableCountriesIso2?: string[]) => {
  if (!dialCode) return undefined;

  return getDialCodeList(availableCountriesIso2).find((item) => parseInt(item.dialCode) === parseInt(dialCode));
};
